<template>
  <div>
    <div class="btn-group btn-group-justified">
     <button @click="addKeyboard" type="button" class="btn btn-outline-secondary btn-sm">Reply Buttons</button>
     <button @click="addInlineKeyboard" type="button" class="btn btn-outline-secondary btn-sm">Inline Buttons</button>
     <button @click="removeReplyKeyboard" type="button" class="btn btn-outline-secondary btn-sm">Remove Reply Buttons</button>
     <button @click="removeKeyboard" type="button" class="btn btn-outline-danger btn-sm">Remove</button>
    </div>

   <div v-if="reply_markup && reply_markup.keyboard" class="form-check">
     <label class="form-check-label">
       <input type="checkbox" class="form-check-input" v-model="reply_markup.resize_keyboard" ><h6>Resize Buttons</h6>
     </label>
   </div>

   <ReplyKeyboard v-if="reply_markup && reply_markup.keyboard" :keyboard="reply_markup.keyboard" :actions="actions">
   </ReplyKeyboard>

   <InlineKeyboard v-if="reply_markup && reply_markup.inline_keyboard" :inline_keyboard="reply_markup.inline_keyboard" :actions="actions">
   </InlineKeyboard>

   <div v-if="reply_markup && reply_markup.remove_keyboard" class="m-3">
      <h6>Removes Existing Reply Keyboard Buttons</h6>
   </div>

  </div>
</template>


<script>
import ReplyKeyboard from '@/components/tasks/fields/ReplyKeyboard.vue'
import InlineKeyboard from '@/components/tasks/fields/InlineKeyboard.vue'



export default {
  name: 'ReplyMarkup',
  components:{
    ReplyKeyboard,
    InlineKeyboard
  },
  props: {
    reply_markup:Object,
    actions: Object,
  },
  data: function () {
    return {
      keyboard: {"keyboard":[],"resize_keyboard":true},
      inline_keyboard: {"inline_keyboard":[]},
      remove_reply_keyboard: {"remove_keyboard":true}
    }
  },
  methods:{
    addKeyboard: function(){
        this.$emit('changeReplyMarkup', this.keyboard);
        },
    addInlineKeyboard: function(){
        this.$emit('changeReplyMarkup', this.inline_keyboard);
        },
    removeKeyboard: function(){
        this.$emit('changeReplyMarkup', null);
        },
    removeReplyKeyboard: function(){
        this.$emit('changeReplyMarkup', this.remove_reply_keyboard);
        },
  },
}
</script>
